import type { DocumentItem } from 'shared/src'

export const BULK_DELETE_BATCH_SIZE = 100

export const FILE_TYPE_META: Record<DocumentItem['fileType'], { icon: string; label: string }> = {
  'text/plain': {
    icon: 'ai-summary',
    label: 'TXT',
  },
  'application/pdf': {
    icon: 'list',
    label: 'PDF',
  },
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': {
    icon: 'ai-summary',
    label: 'DOCX',
  },
  'text/html': {
    icon: 'code',
    label: 'HTML',
  },
  'application/vnd.openxmlformats-officedocument.presentationml.presentation': {
    icon: 'ai-summary',
    label: 'PPTX',
  },
  'text/asciidoc': {
    icon: 'ai-summary',
    label: 'ADOC',
  },
  'text/markdown': {
    icon: 'code',
    label: 'MD',
  },
}
